module.exports = __webpack_public_path__ + "static/media/corpu_cover.ff66507c.jpg";